export default "__VITE_ASSET__494a6f8c__"